import { Theme } from '@mui/material/styles';

// ----------------------------------------------------------------------

export default function Input(theme: Theme) {
  return {
    MuiInputBase: {
      styleOverrides: {
        root: {
          '& svg': {
            color: theme?.palette?.branded?.carbon,
          },
          borderRadius: '0 !important',
          '&.Mui-disabled': {
            '& svg': { color: theme.palette.text.disabled },
          },
        },
        input: {
          textOverflow: 'ellipsis',
          '&::placeholder': {
            opacity: 1,
            color: theme.palette.text.disabled,
          },
          'WebkitBoxShadow': '0 0 0px 1000px white inset',
          '&::-ms-reveal': {
            display: 'none',
          }
        },
      },
    },
    MuiInput: {
      styleOverrides: {
        underline: {
          '&:before': {
            borderBottomColor: theme.palette.grey[500_56],
          },
        },
      },
    },
    MuiFilledInput: {
      styleOverrides: {
        root: {
          backgroundColor: theme.palette.grey[500_12],
          '&:hover': {
            backgroundColor: theme.palette.grey[500_16],
          },
          '&.Mui-focused': {
            backgroundColor: theme.palette.action.focus,
          },
          '&.Mui-disabled': {
            backgroundColor: theme.palette.action.disabledBackground,
          },
        },
        underline: {
          '&:before': {
            borderBottomColor: theme.palette.grey[500_56],
          },
        },
      },
    },
    // label style
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: theme.palette.grey[300],
          '&.Mui-focused': {
            color: theme.palette.grey[300],
          },
          '&.Mui-disabled': {
            color: theme.palette.grey[300]
          }
        },
      }
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          background: theme.palette.background.paper,
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.palette.grey[300],
          },
          '&.Mui-disabled': {
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: theme.palette.action.disabledBackground,
            },
          },
          '&.Mui-focused': {
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: theme.palette.grey[300],
            },
          }
        },
      },
    },
  };
}
